import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import 'rc-collapse/assets/index.css';
import 'rc-checkbox/assets/index.css';
import store from './configureStore';

import CustomRouter from './components/Router';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './styles/design-system.css';
import './v2/base.css';
import './v2/shared-controls.css';
import './v2/styles.css';
import './v2/toasts.css';
import './v2/portable.css';
import '../i18n.ts';
import './numbroConfig.ts';
import App from './containers/App/index.tsx';
import { DesignVersionProvider } from './context/DesignVersionContext';
import { Suspense } from 'react';
import DesignThemeProvider from './components/DesignThemeProvider/DesignThemeProvider';

export const history = createBrowserHistory();

ReactDOM.createRoot(document.getElementById('app')!).render(
  <Provider store={store}>
    <CustomRouter history={history}>
      <Suspense>
        <DesignVersionProvider>
          <DesignThemeProvider>
            <App />
          </DesignThemeProvider>
        </DesignVersionProvider>
      </Suspense>
    </CustomRouter>
  </Provider>,
);
